import { render, staticRenderFns } from "./WhoAreWe.vue?vue&type=template&id=50f0e974&scoped=true"
import script from "./WhoAreWe.vue?vue&type=script&lang=js"
export * from "./WhoAreWe.vue?vue&type=script&lang=js"
import style0 from "./WhoAreWe.vue?vue&type=style&index=0&id=50f0e974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0e974",
  null
  
)

export default component.exports